import React, {useContext} from "react";
import {observer} from "mobx-react";
import {useTranslation} from "react-i18next";
import {AgreementsControllerContext} from "../agreements.controller";
import {Agreement} from "../../../../models/agreements/agreement";
import {Checkbox, Card, Col, Tooltip, Typography, Popconfirm} from "antd";

interface AgreementItemProps {
    agreement: Agreement
}

export const AgreementItem: React.FC<AgreementItemProps> = observer(({agreement}) => {
    const controller = useContext(AgreementsControllerContext);
    const {t} = useTranslation('translation', {useSuspense: false});

    return (
        <Col className="card-col" xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
            <Card
                className={"card"}
                title={<Typography.Text title={t(agreement.name)} ellipsis>{t(agreement.name)}</Typography.Text>}
                extra={
                    agreement.approval ? (
                        <Popconfirm
                            title={t("ARE_YOU_SURE")}
                            onConfirm={() => controller.onAgreementCheck(false, agreement)}
                            placement="top"
                            okText={t("YES")}
                            cancelText={t("NO")}
                        >
                            <Tooltip placement="topRight" title={t("MARKETING_AGREEMENT.DISAPPROVE")}>
                                <Checkbox className="large" checked={agreement.approval}/>
                            </Tooltip>
                        </Popconfirm>
                    ) : (
                        <Tooltip placement="topRight" title={t("MARKETING_AGREEMENT.APPROVE")}>
                            <Checkbox
                                className="large"
                                onChange={e => controller.onAgreementCheck(true, agreement)}
                                checked={agreement.approval}
                            />
                        </Tooltip>
                    )
                }
            >
                <Typography.Paragraph style={{whiteSpace: "pre-line"}}>{t(agreement.description)}</Typography.Paragraph>
            </Card>
        </Col>
    )
})